<template>
    <div class="rc-dropdown-divider">
        <hr>
    </div>
</template>

<script >

</script>

<style scoped>
.rc-dropdown-divider {
    padding: 0;
    margin: -15px 0;
    pointer-events: none;
}
</style>